<template>
	<div class="container">
		<HotRankGridListItem
			v-for="(item, idx) in props.data"
			:key="idx"
			:data="item"
			@click="onClickCard(item.hot_ranking_pk, item.hot_ranking_category_pk)"
		/>
	</div>
</template>
<script setup lang="ts">
import { hotrankingCategorys } from '@/api/hotRanking';
import HotRankGridListItem from '@/components/hotRank/HotRankGridListItem.vue';

const props = defineProps<{
	data: hotrankingCategorys[];
}>();

const emit = defineEmits(['upload:item']);
const onClickCard = (pk: number, categoryPk: number) => {
	emit('upload:item', pk, categoryPk);
};
</script>

<style lang="scss" scoped>
.container {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	// grid-template-rows: repeat(3, 1fr);
	gap: 1rem;
}
</style>
